<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ title }}
    </h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="invitation-link">
      <p class="description">
        {{ "invitation-link-dialog.description" | translate }}
      </p>

      <div class="link-row">
        <!-- scanner-disable-next-line R6 -- native-element-driven select-on-focus copy field (WAP-1568) -->
        <input
          type="text"
          class="link-input"
          [value]="link"
          readonly
          (focus)="$any($event.target).select()"
        />
        <sui-button
          size="sm"
          variant="primary"
          [leadingIcon]="['fas', 'copy']"
          (click)="copyToClipboard()"
        >
          {{ "btn.copy" | translate }}
        </sui-button>
      </div>
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.close" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
